export default class Feriado {
    constructor() {
        this.id = null;
        this.data = null;
        this.descricao = '';
        this.abrangencia = 1;
        this.fixo = true;
        this.cidade = {id: null, nome: ''};
        this.estado = {id: null, nome: ''};
        this.cargos = [];
        this.centrosCustos = [];
    }    
}